import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { UserContext } from "../../context/user-context";
import { SessionContext } from "../../context/session-context";

var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

export default function MyDetailsPanel(props) {

  const useStyles = makeStyles({
    root:{
      width: props.width,
      minWidth: 380,
      minHeight: 350,

    },
    selectButton:{
      marginTop: 20,
      backgroundColor:'#2D2F88',
      color: '#FFF',
      '&:hover': {
        color: '#F6A036',
      },
      fontSize:10
    },
    styleContainer:{
      marginLeft:10,
      border: '1px solid #D2D2D8',
      '& .MuiInputBase-root': {
        fontSize: 12,
      },
      '& .MuiInputLabel-root': {
        fontSize: 14,
      },
    }, 
    userContainer:{
      margin:10,
    },
    textField:{
      width:'60%',
      minWidth: 140,

    }, 
    textFieldLong:{
      width:'80%',
      minWidth: 200,
      '&: .MuiInputBase-input': {
        fontSize: 10,
      },
    },
    textHeader:{
      fontSize: 14,
      fontWeight: 600,
      marginBottom: 10,
      textTransform: 'uppercase'
    },
    actionButton:{
      marginTop: 20,
      color: '#FFFFFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        color: '#FFFFFF',
        backgroundColor: '#63D764',
      },
      minWidth:120,
      height:32,
      fontSize:10
    },
});


  const classes = useStyles();
  const [sState] = useContext(SessionContext);
  const [uState, uDispatch] = useContext(UserContext);
  
  const [uid, setUid] = useState('');
  const [name, setName] = useState('');
  const [hasNameError, setHasNameError] = useState(false);
  const [hasNameErrorLabel, setHasNameErrorLabel] = useState('');
  const [email, setEmail] = useState('');
  const [hasEmailError, setHasEmailError] = useState(false);
  const [hasEmailErrorLabel, setHasEmailErrorLabel] = useState('');
  const [status, setStatus] = useState('');
  const [uType, setUType] = useState('');

  const [findid, setFindid] = useState('');
  const [aid, setAid] = useState('');
  const [companyname, setCompanyname] = useState('');
  const [hasCompanyError, setHasCompanyError] = useState(false);
  const [hasCompanyErrorLabel, setHasCompanyErrorLabel] = useState('');
  const [address1, setAddress1] = useState('');
  const [hasAddressError, setHasAddressError] = useState(false);
  const [hasAddressErrorLabel, setHasAddressErrorLabel] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [county, setCounty] = useState('');
  const [country, setCountry] = useState('');
  const [postcode, setPostcode] = useState('');
  const [telephone, setTelephone] = useState('');
  const [hasTelephoneError, setHasTelephoneError] = useState(false);
  const [hasTelephoneErrorLabel, setHasTelephoneErrorLabel] = useState('');


  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [severity, setSeverity] = useState('success');
  const [msg, setMsg] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  /**
   * Loads and displays the current user details.
  */
 useEffect(() => {
  const abortController = new AbortController();

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/mydetail?uid='+parseInt(sState.userid)+'&ident='+sState.ident, {
          method: 'GET',
          headers: {'Content-Type': 'application/json'},
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            setUid(data.details.userid)
            setName(data.details.username);
            setEmail(data.details.useremail);
            setStatus(data.details.userstatus);
            setUType(data.details.userutype);
          
            setAid(data.details.companyid)
            setFindid(data.details.findid);
            setCompanyname(data.details.companyname);
            setAddress1(data.details.address1);
            setAddress2(data.details.address2);
            setCity(data.details.city);
            setCounty(data.details.county);
            setCountry(data.details.country);
            setPostcode(data.details.postcode);
            setTelephone(data.details.telephone);

            if (data.details.userutype === 'manager' || data.details.userutype === 'admin'){
              setCanEdit(true);
            } else {
              setCanEdit(false);
            }
          } else {

          }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
      
},[]);


  /**
   * Saves the user changes.
   */
  const handleUpdate = () => {

    let hasError = false;
    if (name.length < 1){ setHasNameError(true); setHasNameErrorLabel('Your name is required'); hasError = true;} else { setHasNameError(false); setHasNameErrorLabel('') }
    if (email.length < 1){ setHasEmailError(true); setHasEmailErrorLabel('Your email is required'); hasError = true;} else { setHasEmailError(false); setHasEmailErrorLabel('');}

    if (!hasError){
      const abortController = new AbortController();
      const request = {
        ident:sState.ident,
        userid:sState.userid,
        name: name,
        email: email,
        status: status,
        utype: uType
      };
      let mounted = true;
      (async () => {
  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/update', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          
          if (data.status === "success"){
            setSeverity('success')
            setMsg('Update complete.')

            handleUserUpdateComplete();

          } else {
            setSeverity('error')
            setMsg('Failed to update details..')
          }
          setSnackOpen(true);

        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
      })();
    }

  };

  const handleUserUpdateComplete = () => {

    const user = uState.user;
    user.name = name;
    user.email = email;
    uDispatch({
      type: "updateuser",
      payload: { user: user }
    });
  }

  const handleClose = () => {
    setSnackOpen(false);
  }

  /**
   * Saves the company changes.
   */
   const handleCompanyUpdate = () => {

    let hasError = false;
    if (companyname.length < 3){ setHasCompanyError(true); setHasCompanyErrorLabel('Companyname is required'); hasError = true;} else { setHasCompanyError(false); setHasCompanyErrorLabel('') }
    if (address1.length < 3){ setHasAddressError(true); setHasAddressErrorLabel('Address is required'); hasError = true;} else { setHasAddressError(false); setHasAddressErrorLabel('');}
    if (telephone.length < 6){ setHasTelephoneError(true); setHasTelephoneErrorLabel('Telephone number is required'); hasError = true;} else { setHasTelephoneError(false); setHasTelephoneErrorLabel('');}
    
    if (!hasError){
      const abortController = new AbortController();
      const request = {
        ident:sState.ident,
        companyid:aid,
        companyname: companyname,
        address1: address1,
        address2: address2,
        town: city,
        county: county,
        country: country,
        postcode: postcode,
        telephone: telephone
      };
  
      let mounted = true;
      (async () => {
  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/company/update', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            setSeverity('success')
            setMsg('Update complete.')
            handleCompanyUpdateComplete();

          } else {
            setSeverity('error')
            setMsg('Failed to update details.')
          }
          setSnackOpen(true);
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
      })();
    }

  };

  const handleCompanyUpdateComplete = () => {

    const user = uState.user;
    user.name = name;
    user.email = email;
    uDispatch({
      type: "updateuser",
      payload: { user: user }
    });
  }

  return (
    <div className={classes.root}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackOpen} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
          {msg}
          </Alert>
      </Snackbar>
      <Grid container>
        <Grid item xs={6}>
          <div className={classes.styleContainer}>
              <Grid container className={classes.userContainer}>
                <Grid item xs={12}>
                  <Box className={classes.textHeader}>User Details</Box>
                </Grid>
                <Grid item xs={12}>
                  <TextField className={classes.textField} error={hasNameError} helperText={hasNameErrorLabel} name="name" label="Your name" size="small" margin="dense" variant="outlined" value={name} onChange={e => setName(e.target.value)} required/> 
                </Grid>
                <Grid item xs={12}>
                  <TextField type="email" error={hasEmailError} helperText={hasEmailErrorLabel} className={classes.textFieldLong} name="email" label="Your email" size="small" margin="dense" variant="outlined" value={email} onChange={e => setEmail(e.target.value)} required/>
                </Grid>
                <Grid item xs={12}>
                  {hasError ? <Box className={classes.errorTxt}>{errorMsg}</Box> : ''}
                  <Button className={classes.actionButton} onClick={handleUpdate}>
                      Update
                  </Button>
                </Grid>
              </Grid>
            </div>
        </Grid>
        <Grid item xs={6}>
        <div className={classes.styleContainer}>
            <Grid container className={classes.userContainer}>
            <Grid item xs={12}>
                <Box className={classes.textHeader}>Company Details</Box>
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textField} name="id" label="Account ID" size="small" margin="dense" variant="outlined" value={findid} editable={false}/> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textFieldLong} error={hasCompanyError} helperText={hasCompanyErrorLabel}  name="companyname" label="Companyname" size="small" margin="dense" variant="outlined" editable={canEdit} value={companyname} onChange={e => setCompanyname(e.target.value)} required/> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textFieldLong} error={hasAddressError} helperText={hasAddressErrorLabel} name="address1" label="Address line 1" size="small" margin="dense" variant="outlined" editable={canEdit} value={address1} onChange={e => setAddress1(e.target.value)} required/> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textFieldLong} name="address2" label="Address line 2" size="small" margin="dense" variant="outlined" editable={canEdit} value={address2} onChange={e => setAddress2(e.target.value)} /> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textFieldLong} name="city" label="City" size="small" margin="dense" variant="outlined" editable={canEdit} value={city} onChange={e => setCity(e.target.value)} /> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textFieldLong} name="county" label="County" size="small" margin="dense" variant="outlined" editable={canEdit} value={county} onChange={e => setCounty(e.target.value)} /> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textFieldLong} name="country" label="Country" size="small" margin="dense" variant="outlined" editable={canEdit} value={country} onChange={e => setCountry(e.target.value)} /> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textField} name="postcode" label="Postcode" size="small" margin="dense" variant="outlined" editable={canEdit} value={postcode} onChange={e => setPostcode(e.target.value)} /> 
              </Grid>
              <Grid item xs={12}>
                <TextField className={classes.textField} error={hasTelephoneError} helperText={hasTelephoneErrorLabel} name="telephone" label="Telephone" size="small" margin="dense" variant="outlined" editable={canEdit} value={telephone} onChange={e => setTelephone(e.target.value)} required/> 
              </Grid>
              <Grid item xs={12}>
                  {hasError ? <Box className={classes.errorTxt}>{errorMsg}</Box> : ''}
                  <Button className={classes.actionButton} onClick={handleCompanyUpdate} disabled={!canEdit}>
                      Update
                  </Button>
                </Grid>
            </Grid>

        </div>
        </Grid>
      </Grid>
    </div> 
  );
}